import { HttpErrorResponse } from '@angular/common/http';

export interface NetworkErrorInfo {
  isNetworkError: boolean;
  isOffline: boolean;
  shouldRetry: boolean;
  retryDelay: number;
  maxRetries: number;
}

export interface ConnectionStatusMessage {
  message: string;
  isError: boolean;
  showRetry: boolean;
}

/**
 * Analyzes an HTTP error to determine if it's a network connectivity issue
 */
export function analyzeNetworkError(error: HttpErrorResponse): NetworkErrorInfo {
  const isNetworkError = error.status === 0;
  const isOffline = !navigator.onLine;

  return {
    isNetworkError,
    isOffline,
    shouldRetry: isNetworkError && !isOffline,
    retryDelay: 2000, // 2 seconds
    maxRetries: 3,
  };
}

/**
 * Gets user-friendly connection status messages
 */
export function getConnectionStatusMessage(isOnline: boolean): ConnectionStatusMessage {
  if (isOnline) {
    return {
      message: 'Connected',
      isError: false,
      showRetry: false,
    };
  } else {
    return {
      message: 'Connection lost, retrying to connect...',
      isError: true,
      showRetry: true,
    };
  }
}

/**
 * Logs network errors with appropriate detail level
 */
export function logNetworkError(error: HttpErrorResponse, context?: string): void {
  const errorInfo = analyzeNetworkError(error);
  const contextPrefix = context ? `[${context}] ` : '';

  if (errorInfo.isNetworkError) {
    if (errorInfo.isOffline) {
      console.warn(`${contextPrefix}Network offline - request failed`);
    } else {
      console.warn(`${contextPrefix}Network error - request failed:`, error.message);
    }
  } else {
    console.error(`${contextPrefix}HTTP error:`, error);
  }
}
